import type {
  WorkflowDecisionInDto,
  WorkflowDecisionOutDto,
} from 'shared/domain/workflow/types';

export interface IDecisionUploader {
  POST: (url: string, data: WorkflowDecisionInDto) => Promise<WorkflowDecisionOutDto>;
}

export type UploadDecision = (
  uploader: IDecisionUploader,
  body: WorkflowDecisionInDto,
  url: string
) => Promise<WorkflowDecisionOutDto>;

export function uploadDecision(
  uploader: IDecisionUploader,
  body: WorkflowDecisionInDto,
  url: string
): Promise<WorkflowDecisionOutDto> {
  return uploader.POST(url, body);
}
